import * as React from 'react';
import b_ from 'b_';
import { useTranslation } from 'react-i18next';
import { OverlayProps } from 'components/SingleTooltip';
import { ArchiveIdeaButton } from '../../../ArchiveIdeaButton';
import { ArchiveStockButton } from '../../../ArchiveStockButton';

import './index.scss';
import { Investment_IdeaType } from 'types/common';

const b = b_.with('overlay-card-archive');

export interface Props extends OverlayProps {
  orderId: number;
  productType: 'idea' | 'stocks';
  ideaType?: Investment_IdeaType;
}

export const ArchiveTooltip: React.FC<Props> = ({ close, productType, orderId, ideaType }) => {
  const { t } = useTranslation();

  return (
    <div className={b()}>
      <p>{t('Are you sure that you want to move to archive this order?')}</p>
      <div className={b('buttons')}>
        {productType === 'idea' && (
          <ArchiveIdeaButton orderId={orderId} ideaType={ideaType!}>
            {t('Archive')}
          </ArchiveIdeaButton>
        )}
        {productType === 'stocks' && (
          <ArchiveStockButton orderId={orderId}>{t('Archive')}</ArchiveStockButton>
        )}
        <button className={b('cancel-btn')} onClick={close}>
          {t('Cancel')}
        </button>
      </div>
    </div>
  );
};
